export default __webpack_public_path__ + "f4b364b9903cb1d0913db29e0953acea.svg";